import axios from "axios"; //创建一个axios的对象
//生成一个axios的实例
const http = axios.create({
  baseURL: "http://1.94.56.12:8081/", // baseURL会在发送请求的时候拼接在url参数前面
  // baseURL:"http://192.168.30.188:8081/",// baseURL会在发送请求的时候拼接在url参数前面
  timeout: 120000, //请求超时
});
// Request interceptors for API calls
http.interceptors.request.use(
  (config) => {
    // config.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
    config.headers["Cache-Control"] = `no-cache`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export const BASE_URL = "http://1.94.56.12:8081/";
export const UPLOAD_URL = "http://1.94.56.12:8081";
// export const BASE_URL = "http://192.168.30.188:8081/";
// export const UPLOAD_URL = "http://192.168.30.188:8081";
export default http; //导出
